import { Box, Typography } from '@mui/material';
import React from 'react';
import { FightResult } from '../../../../../../corelogic/domain/models/fightResult.enum';

interface FightResultCircleProps {
  result: FightResult;
  isTitleFight: boolean;
}

const FightResultCircle: React.FC<FightResultCircleProps> = ({
  result,
  isTitleFight,
}) => {
  const getCircleStyles = () => {
    const baseStyles = {
      width: 15,
      height: 15,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 2px',
      border: isTitleFight ? '1px solid #FFD700' : 'none',
    };

    switch (result) {
      case FightResult.WIN:
        return {
          ...baseStyles,
          backgroundColor: '#4CAF50', // Green
          color: 'white',
        };
      case FightResult.LOSS:
        return {
          ...baseStyles,
          backgroundColor: '#f44336', // Red
          color: 'white',
        };
      case FightResult.DRAW:
      case FightResult.NO_CONTEST:
        return {
          ...baseStyles,
          backgroundColor: '#9e9e9e', // Light Grey
          color: 'white',
        };
      case FightResult.NONE:
        return {
          ...baseStyles,
          backgroundColor: '#424242', // Dark Grey
        };
    }
  };

  const getResultText = () => {
    switch (result) {
      case FightResult.WIN:
        return 'W';
      case FightResult.LOSS:
        return 'L';
      case FightResult.DRAW:
        return 'D';
      case FightResult.NO_CONTEST:
        return 'NC';
      default:
        return '';
    }
  };

  return (
    <Box sx={getCircleStyles()}>
      <Typography
        sx={{
          fontSize: result === FightResult.NO_CONTEST ? '0.4rem' : '0.5rem',
          fontWeight: 'bold',
          fontFamily: 'Bebas Neue',
          lineHeight: 1,
          marginTop: '1px',
        }}
      >
        {getResultText()}
      </Typography>
    </Box>
  );
};

export default FightResultCircle;
